import api from './axios';

export const backupLogAPI = {
  // Get all backup logs (admin view)
  getAll: async (page = 1, limit = 20, status = '') => {
    const params = { page, limit };
    if (status) params.status = status;
    const response = await api.get('/backup-logs', { params });
    return response.data;
  },

  // Get logs by installation
  getByInstallation: async (uniqueId, page = 1, limit = 20, status = '') => {
    const params = { page, limit };
    if (status) params.status = status;
    const response = await api.get(`/installation/${uniqueId}/backup-logs`, { params });
    return response.data;
  },

  // Get logs by config
  getLogsByConfig: async (configId, page = 1, limit = 20, status = '') => {
    const params = { page, limit };
    if (status) params.status = status;
    const response = await api.get(`/backup-config/${configId}/logs`, { params });
    return response.data;
  },

  // Get single log details
  getLogById: async (logId) => {
    const response = await api.get(`/backup-log/${logId}`);
    return response.data;
  },

  // Get running backups
  getRunningBackups: async () => {
    const response = await api.get('/backup-logs/running');
    return response.data;
  },

  // Get backup statistics
  getStatistics: async (uniqueId, days = 7) => {
    const response = await api.get(`/installation/${uniqueId}/backup-stats`, {
      params: { days }
    });
    return response.data;
  }
};